
export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-blue-600 to-purple-600 rounded-lg flex items-center justify-center">
                <i className="ri-shield-keyhole-line text-white text-xl"></i>
              </div>
              <span className="text-xl font-bold">TOZA MARKOVIC</span>
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed">
              TOZA MARKOVIC DOO KIKINDA is dedicated to providing cutting-edge VPN solutions that protect your online privacy and security. Trust us to keep your digital life safe.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-twitter-x-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li><a href="#home" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Home</a></li>
              <li><a href="#features" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Features</a></li>
              <li><a href="#about" className="text-gray-400 hover:text-white transition-colors cursor-pointer">About</a></li>
              <li><a href="#contact" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Contact</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Contact Info</h4>
            <ul className="space-y-3 text-gray-400">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-1 flex-shrink-0"></i>
                <span>BASAIDSKI DRUM 62, Kikinda, Serbia</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line flex-shrink-0"></i>
                <a href="mailto:info@tozamarkovicdookikinda.com" className="hover:text-white transition-colors cursor-pointer">info@tozamarkovicdookikinda.com</a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line flex-shrink-0"></i>
                <a href="tel:+19088833445" className="hover:text-white transition-colors cursor-pointer">+1 908-883-3445</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {currentYear} TOZA MARKOVIC DOO KIKINDA. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Privacy Policy</a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Terms of Service</a>
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Powered by Readdy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
